export const translations = {
  en: {
    // Navigation
    navCCTV: 'CCTV',
    navRO: 'RO WATER',
    navContact: 'CONTACT',
    
    // Hero Section
    heroBadge: 'SYSTEM ACTIVE • Trusted Since 2010',
    heroTitle1: 'SMART',
    heroTitle2: 'SECURITY SYSTEMS',
    heroSubtitle: '[ SURVEILLANCE • MONITORING • PROTECTION ]',
    heroDescription: 'Advanced CCTV Surveillance & Smart Security Solutions',
    heroText: 'Professional installation and maintenance of CCTV cameras and integrated security systems for residential, commercial, and institutional facilities',
    heroButton1: 'View Security Solutions',
    heroButton2: 'REQUEST QUOTE',
    heroStat1: 'Secured Locations',
    heroStat2: 'Cameras Installed',
    heroStat3: 'Years Experience',
    heroStat4: 'Monitoring',
    heroScroll: 'SCROLL',
    
    // RO Hero Section
    roHeroBadge: 'PURE WATER SINCE 2010',
    roHeroTitle1: 'RO WATER',
    roHeroTitle2: 'PURIFICATION SYSTEMS',
    roHeroSubtitle: 'Clean, Pure, Safe Drinking Water',
    roHeroDescription: 'Professional installation & maintenance services for residential, commercial & institutional facilities',
    roHeroButton1: 'View Our Services',
    roHeroButton2: 'GET FREE QUOTE',
    roHeroStat1: 'Systems Installed',
    roHeroStat2: 'Happy Customers',
    roHeroStat3: 'Years Experience',
    roHeroStat4: 'Service Support',
    roHeroScroll: 'SCROLL',
    
    // RO About Section
    roAboutBadge: '[ ABOUT RO SYSTEMS ]',
    roAboutTitle: 'Pure Water',
    roAboutTitle2: 'Solutions',
    roAboutCard1Title: 'Professional Installation',
    roAboutCard1Text: 'We provide expert installation of RO water purification systems for both domestic and commercial use. Our certified technicians ensure proper setup, optimal performance, and water quality testing.',
    roAboutCard2Title: 'Regular Maintenance',
    roAboutCard2Text: 'Comprehensive maintenance and servicing to ensure your RO system operates at peak efficiency. We offer filter replacement, membrane cleaning, and water quality monitoring services.',
    roAboutBottomTitle: 'Your Trusted Water Purification Partner',
    roAboutBottomText: 'Operating from Raptinagar, Gorakhpur, we specialize in providing reliable RO water purification solutions. Our commitment to quality ensures clean, safe drinking water for residential, commercial, and institutional facilities.',
    
    // RO Services Section
    roServicesBadge: '[ OUR SERVICES ]',
    roServicesTitle: 'RO Water',
    roServicesTitle2: 'Solutions',
    roServicesSubtitle: 'Complete Water Purification Services',
    roService1Title: 'Domestic RO Systems',
    roService1Desc: 'Compact and efficient RO systems designed for home use. Perfect for families seeking clean, purified drinking water with easy maintenance and reliable performance.',
    roService1Feature1: '7-Stage Filtration',
    roService1Feature2: 'UV Sterilization',
    roService1Feature3: 'TDS Controller',
    roService1Feature4: 'Auto Shut-off',
    roService1Feature5: 'Easy Installation',
    roService1Feature6: 'Regular Maintenance',
    roService2Title: 'Commercial RO Systems',
    roService2Desc: 'High-capacity RO systems for offices, restaurants, and commercial establishments. Designed to handle large water volumes while maintaining consistent water quality.',
    roService2Feature1: 'High Capacity',
    roService2Feature2: 'Multi-Stage Filtration',
    roService2Feature3: 'Commercial Grade',
    roService2Feature4: 'Energy Efficient',
    roService2Feature5: 'Professional Setup',
    roService2Feature6: '24/7 Support',
    roService3Title: 'RO Maintenance & Service',
    roService3Desc: 'Comprehensive maintenance services to keep your RO system running efficiently. We provide filter replacement, membrane cleaning, and water quality testing.',
    roService3Feature1: 'Filter Replacement',
    roService3Feature2: 'Membrane Cleaning',
    roService3Feature3: 'Water Testing',
    roService3Feature4: 'System Inspection',
    roService3Feature5: 'Preventive Maintenance',
    roService3Feature6: 'Emergency Repairs',
    roServicesWhyTitle: 'WHY CHOOSE US?',
    roServicesWhySubtitle: 'Professional Water Purification Excellence',
    roServicesWhy1: 'EXPERT INSTALLATION',
    roServicesWhy1Desc: 'Professional setup by certified technicians',
    roServicesWhy2: 'QUALITY ASSURANCE',
    roServicesWhy2Desc: 'Premium RO systems and components',
    roServicesWhy3: 'REGULAR SERVICE',
    roServicesWhy3Desc: 'Comprehensive maintenance and after-sales service',
    
    // About Section
    aboutBadge: '[ ABOUT US ]',
    aboutTitle: 'Welcome to',
    aboutTitle2: 'Smart Security And RO Systems',
    aboutCard1Title: 'SPECIALIZED SOLUTIONS',
    aboutCard1Text: 'We deliver end-to-end solutions in electronic security infrastructure. Our focus is on supply, installation, maintenance, and servicing of CCTV surveillance cameras, smart security systems, access control systems, alarm systems, and integrated security solutions for residential, commercial, and institutional facilities.',
    aboutCard2Title: '24/7 MONITORING',
    aboutCard2Text: 'With a customer-centric operating model, we address both new installations and after-sales service requirements, ensuring system reliability, operational continuity, and long-term performance for residential, commercial, and institutional use cases.',
    aboutBottomTitle: 'YOUR TRUSTED SECURITY PARTNER',
    aboutBottomText: 'Operating from Raptinagar, Gorakhpur, Smart Security And RO Systems positions itself as a dependable local partner, combining technical expertise with responsive service delivery to meet safety and surveillance needs efficiently and cost-effectively.',
    
    // Services Section
    servicesBadge: '[ OUR SERVICES ]',
    servicesTitle: 'SECURITY',
    servicesTitle2: 'SOLUTIONS',
    servicesSubtitle: 'Professional CCTV & Water Purification Systems',
    service1Title: 'CCTV Surveillance Cameras',
    service1Desc: 'Advanced CCTV camera systems for comprehensive security monitoring. From single camera setups to complex multi-camera networks, we deliver reliable surveillance solutions.',
    service2Title: 'Advanced Security Systems',
    service2Desc: 'Intelligent security solutions with AI-powered detection, facial recognition, and automated alerts. Complete protection for your property with cutting-edge technology.',
    service3Title: 'Integrated Security Solutions',
    service3Desc: 'Complete security infrastructure including access control, alarm systems, and integrated security management. Tailored solutions for residential, commercial, and institutional needs.',
    serviceButton: 'VIEW DETAILS',
    servicesWhyTitle: 'WHY CHOOSE US?',
    servicesWhySubtitle: 'Professional Security Solutions & Service Excellence',
    servicesWhy1: 'QUICK RESPONSE',
    servicesWhy1Desc: 'Fast and efficient service delivery',
    servicesWhy2: 'EXPERT INSTALLATION',
    servicesWhy2Desc: 'Professional setup by certified technicians',
    servicesWhy3: '24/7 SUPPORT',
    servicesWhy3Desc: 'Comprehensive monitoring and after-sales service',
    
    // Features Section
    featuresBadge: '[ ADVANCED FEATURES ]',
    featuresTitle: 'SMART',
    featuresTitle2: 'TECHNOLOGY',
    featuresSubtitle: 'Cutting-edge security features for ultimate protection',
    feature1Title: '24/7 Live Monitoring',
    feature1Desc: 'Round-the-clock surveillance with real-time alerts and instant notifications',
    feature2Title: 'AI-Powered Detection',
    feature2Desc: 'Advanced motion detection and facial recognition technology',
    feature3Title: 'Mobile Access',
    feature3Desc: 'Monitor your property from anywhere using our mobile app',
    feature4Title: 'Cloud Storage',
    feature4Desc: 'Secure cloud backup for all your surveillance footage',
    feature5Title: 'Encrypted Security',
    feature5Desc: 'Military-grade encryption to protect your data',
    feature6Title: 'Instant Alerts',
    feature6Desc: 'Get notified immediately when suspicious activity is detected',
    
    // RO Features Section
    roFeaturesBadge: '[ ADVANCED FEATURES ]',
    roFeaturesTitle: 'PURE WATER',
    roFeaturesTitle2: 'TECHNOLOGY',
    roFeaturesSubtitle: 'Advanced water purification features for clean, healthy water',
    roFeature1Title: 'Multi-Stage Filtration',
    roFeature1Desc: '7-stage purification process removing impurities, bacteria, and harmful contaminants',
    roFeature2Title: 'TDS Controller',
    roFeature2Desc: 'Maintains essential minerals while removing harmful dissolved solids',
    roFeature3Title: 'UV Sterilization',
    roFeature3Desc: 'Ultraviolet technology eliminates bacteria and viruses for safe drinking water',
    roFeature4Title: 'Auto Shut-off',
    roFeature4Desc: 'Smart system automatically stops when tank is full, saving water and energy',
    roFeature5Title: 'Mineral Retention',
    roFeature5Desc: 'Preserves essential minerals like calcium and magnesium for healthy water',
    roFeature6Title: 'Easy Maintenance',
    roFeature6Desc: 'Simple filter replacement and regular servicing for optimal performance',
    
    // Benefits Section
    benefitsBadge: '[ WHY CHOOSE US ]',
    benefitsTitle: 'BENEFITS OF',
    benefitsTitle2: 'SMART SECURITY',
    benefitsSubtitle: 'Protect what matters most with advanced surveillance technology',
    benefit1Title: 'Peace of Mind',
    benefit1Desc: 'Know your property is protected 24/7 with professional surveillance systems',
    benefit2Title: 'Crime Deterrent',
    benefit2Desc: 'Visible cameras significantly reduce the risk of break-ins and vandalism',
    benefit3Title: 'Evidence Collection',
    benefit3Desc: 'High-quality footage for insurance claims and legal proceedings',
    benefit4Title: 'Remote Monitoring',
    benefit4Desc: 'Check on your property anytime, anywhere through mobile access',
    benefit5Title: 'Cost Effective',
    benefit5Desc: 'Reduce security costs with automated monitoring systems',
    benefit6Title: 'Professional Support',
    benefit6Desc: 'Expert installation and ongoing maintenance by certified technicians',
    
    // RO Benefits Section
    roBenefitsBadge: '[ WHY CHOOSE US ]',
    roBenefitsTitle: 'BENEFITS OF',
    roBenefitsTitle2: 'RO WATER PURIFICATION',
    roBenefitsSubtitle: 'Enjoy clean, healthy, and pure drinking water every day',
    roBenefit1Title: 'Pure & Healthy Water',
    roBenefit1Desc: 'Get crystal clear, contaminant-free water that is safe for your entire family',
    roBenefit2Title: 'Better Taste',
    roBenefit2Desc: 'Remove unpleasant odors and tastes, making water refreshing and enjoyable',
    roBenefit3Title: 'Health Protection',
    roBenefit3Desc: 'Eliminate harmful bacteria, viruses, and chemicals that can cause health issues',
    roBenefit4Title: 'Cost Savings',
    roBenefit4Desc: 'Save money on bottled water and reduce plastic waste',
    roBenefit5Title: 'Convenience',
    roBenefit5Desc: 'Access pure water 24/7 right from your tap, no need to store or buy water',
    roBenefit6Title: 'Mineral Balance',
    roBenefit6Desc: 'TDS controller ensures essential minerals are retained for healthy drinking water',
    
    // Testimonials Section
    testimonialsBadge: '[ CUSTOMER FEEDBACK ]',
    testimonialsTitle: 'WHAT OUR',
    testimonialsTitle2: 'CUSTOMERS SAY',
    testimonialsSubtitle: 'Trusted by hundreds of satisfied customers',
    testimonial1Name: 'Rajesh Kumar',
    testimonial1Role: 'Business Owner',
    testimonial1Text: 'Smart Security And RO Systems installed CCTV cameras at my shop. The quality is excellent and the service is outstanding. I can monitor my shop from anywhere. Highly recommended!',
    testimonial2Name: 'Priya Sharma',
    testimonial2Role: 'Homeowner',
    testimonial2Text: 'Professional installation and great support. The cameras are crystal clear even at night. The mobile app is very user-friendly. Feel much safer now!',
    testimonial3Name: 'Amit Singh',
    testimonial3Role: 'Factory Manager',
    testimonial3Text: 'We installed their security system across our factory. The coverage is comprehensive and the 24/7 monitoring gives us complete peace of mind. Excellent value for money.',
    testimonial4Name: 'Sunita Devi',
    testimonial4Role: 'School Principal',
    testimonial4Text: 'The security system has been a game-changer for our school. Parents feel more secure and we have better control over the premises. Professional team and great service!',
    testimonial5Name: 'Vikram Patel',
    testimonial5Role: 'Restaurant Owner',
    testimonial5Text: 'Installed cameras at my restaurant. The night vision is amazing and the cloud storage is very convenient. Customer service is responsive and helpful.',
    
    // RO Testimonials
    roTestimonial1Name: 'Rajesh Kumar',
    roTestimonial1Role: 'Homeowner',
    roTestimonial1Text: 'Installed RO system at my home. The water quality is excellent and tastes great. The installation was quick and professional. Highly satisfied with the service!',
    roTestimonial2Name: 'Priya Sharma',
    roTestimonial2Role: 'Family',
    roTestimonial2Text: 'Best decision we made! The RO system provides clean, pure water for our entire family. Maintenance service is prompt and the team is very helpful.',
    roTestimonial3Name: 'Amit Singh',
    roTestimonial3Role: 'Office Manager',
    roTestimonial3Text: 'Installed commercial RO system at our office. High capacity and excellent water quality. Employees love the clean drinking water. Great investment!',
    roTestimonial4Name: 'Sunita Devi',
    roTestimonial4Role: 'Restaurant Owner',
    roTestimonial4Text: 'RO system has improved our restaurant operations. Clean water for cooking and drinking. Customers appreciate the quality. Professional installation and service!',
    roTestimonial5Name: 'Vikram Patel',
    roTestimonial5Role: 'Shop Owner',
    roTestimonial5Text: 'RO maintenance service is excellent. Regular filter replacement and water testing ensures we always have pure water. Very reliable and affordable service.',
    
    // Contact Section
    contactBadge: '[ CONTACT US ]',
    contactTitle: 'GET IN',
    contactTitle2: 'TOUCH',
    contactSubtitle: 'Professional Security & Water Solutions Consultation',
    contactInfoTitle: 'CONTACT INFORMATION',
    contactPhone: 'PHONE',
    contactEmail: 'EMAIL',
    contactLocation: 'LOCATION',
    contactWebsite: 'WEBSITE',
    contactHours: 'BUSINESS HOURS',
    contactFormTitle: 'SEND US A MESSAGE',
    contactName: 'NAME *',
    contactEmailPlaceholder: 'your.email@example.com',
    contactPhonePlaceholder: '+91 9876543210',
    contactMessage: 'MESSAGE *',
    contactMessagePlaceholder: 'Tell us about your security requirements...',
    contactSubmit: 'SEND MESSAGE',
    contactMonday: 'Monday - Saturday',
    contactSunday: 'Sunday',
    
    // Footer
    footerQuickLinks: 'QUICK LINKS',
    footerContactInfo: 'CONTACT INFO',
    footerAbout: 'About Us',
    footerServices: 'Services',
    footerContact: 'Contact',
    footerActive: '[ ACTIVE ]',
    footerSolutions: 'Security & Water Solutions',
    
    // Owner Section
    ownerBadge: '[ PROPRIETOR DETAILS ]',
    ownerTitle: 'MEET THE',
    ownerTitle2: 'PROPRIETOR',
    ownerSubtitle: 'Your Trusted Security & Water Solutions Expert',
    ownerName: 'Mr. Ashish Kumar',
    ownerExperience: 'Years of Experience',
    ownerContact: 'Contact Details',
    ownerEmail: 'Email',
    ownerPhone: 'Phone',
  },
  hi: {
    // Navigation
    navCCTV: 'सीसीटीवी',
    navRO: 'आरओ पानी',
    navContact: 'संपर्क करें',
    
    // Hero Section
    heroBadge: 'सिस्टम सक्रिय • 2010 से विश्वसनीय',
    heroTitle1: 'स्मार्ट',
    heroTitle2: 'सुरक्षा प्रणाली',
    heroSubtitle: '[ निगरानी • मॉनिटरिंग • सुरक्षा ]',
    heroDescription: 'उन्नत सीसीटीवी निगरानी और स्मार्ट सुरक्षा समाधान',
    heroText: 'आवासीय, वाणिज्यिक और संस्थागत सुविधाओं के लिए सीसीटीवी कैमरे और एकीकृत सुरक्षा प्रणालियों की पेशेवर स्थापना और रखरखाव',
    heroButton1: 'सुरक्षा समाधान देखें',
    heroButton2: 'उद्धरण अनुरोध करें',
    heroStat1: 'सुरक्षित स्थान',
    heroStat2: 'कैमरे स्थापित',
    heroStat3: 'वर्षों का अनुभव',
    heroStat4: 'निगरानी',
    heroScroll: 'स्क्रॉल',
    
    // RO Hero Section
    roHeroBadge: '2010 से शुद्ध पानी',
    roHeroTitle1: 'आरओ वाटर',
    roHeroTitle2: 'शुद्धिकरण प्रणाली',
    roHeroSubtitle: 'स्वच्छ, शुद्ध, सुरक्षित पीने का पानी',
    roHeroDescription: 'आवासीय, वाणिज्यिक और संस्थागत सुविधाओं के लिए पेशेवर स्थापना और रखरखाव सेवाएं',
    roHeroButton1: 'हमारी सेवाएं देखें',
    roHeroButton2: 'मुफ्त उद्धरण प्राप्त करें',
    roHeroStat1: 'सिस्टम स्थापित',
    roHeroStat2: 'खुश ग्राहक',
    roHeroStat3: 'वर्षों का अनुभव',
    roHeroStat4: 'सेवा सहायता',
    roHeroScroll: 'स्क्रॉल',
    
    // RO About Section
    roAboutBadge: '[ RO सिस्टम के बारे में ]',
    roAboutTitle: 'शुद्ध पानी',
    roAboutTitle2: 'समाधान',
    roAboutCard1Title: 'पेशेवर स्थापना',
    roAboutCard1Text: 'हम घरेलू और वाणिज्यिक दोनों उपयोग के लिए RO जल शुद्धिकरण प्रणालियों की विशेषज्ञ स्थापना प्रदान करते हैं। हमारे प्रमाणित तकनीशियन उचित सेटअप, इष्टतम प्रदर्शन और पानी की गुणवत्ता परीक्षण सुनिश्चित करते हैं।',
    roAboutCard2Title: 'नियमित रखरखाव',
    roAboutCard2Text: 'आपके RO सिस्टम को चरम दक्षता पर चलाने के लिए व्यापक रखरखाव और सेवा। हम फिल्टर प्रतिस्थापन, झिल्ली सफाई और पानी की गुणवत्ता निगरानी सेवाएं प्रदान करते हैं।',
    roAboutBottomTitle: 'आपका विश्वसनीय जल शुद्धिकरण भागीदार',
    roAboutBottomText: 'राप्तीनगर, गोरखपुर से संचालित, हम विश्वसनीय RO जल शुद्धिकरण समाधान प्रदान करने में विशेषज्ञ हैं। गुणवत्ता के प्रति हमारी प्रतिबद्धता आवासीय, वाणिज्यिक और संस्थागत सुविधाओं के लिए स्वच्छ, सुरक्षित पीने का पानी सुनिश्चित करती है।',
    
    // RO Services Section
    roServicesBadge: '[ हमारी सेवाएं ]',
    roServicesTitle: 'RO वाटर',
    roServicesTitle2: 'समाधान',
    roServicesSubtitle: 'पूर्ण जल शुद्धिकरण सेवाएं',
    roService1Title: 'घरेलू RO सिस्टम',
    roService1Desc: 'घरेलू उपयोग के लिए डिज़ाइन किए गए कॉम्पैक्ट और कुशल RO सिस्टम। आसान रखरखाव और विश्वसनीय प्रदर्शन के साथ स्वच्छ, शुद्ध पीने का पानी चाहने वाले परिवारों के लिए आदर्श।',
    roService1Feature1: '7-चरणीय फिल्ट्रेशन',
    roService1Feature2: 'UV नसबंदी',
    roService1Feature3: 'TDS कंट्रोलर',
    roService1Feature4: 'ऑटो शट-ऑफ',
    roService1Feature5: 'आसान स्थापना',
    roService1Feature6: 'नियमित रखरखाव',
    roService2Title: 'वाणिज्यिक RO सिस्टम',
    roService2Desc: 'कार्यालयों, रेस्तरां और वाणिज्यिक प्रतिष्ठानों के लिए उच्च क्षमता वाले RO सिस्टम। लगातार पानी की गुणवत्ता बनाए रखते हुए बड़ी मात्रा में पानी को संभालने के लिए डिज़ाइन किया गया।',
    roService2Feature1: 'उच्च क्षमता',
    roService2Feature2: 'मल्टी-स्टेज फिल्ट्रेशन',
    roService2Feature3: 'वाणिज्यिक ग्रेड',
    roService2Feature4: 'ऊर्जा कुशल',
    roService2Feature5: 'पेशेवर सेटअप',
    roService2Feature6: '24/7 सहायता',
    roService3Title: 'RO रखरखाव और सेवा',
    roService3Desc: 'आपके RO सिस्टम को कुशलतापूर्वक चलाने के लिए व्यापक रखरखाव सेवाएं। हम फिल्टर प्रतिस्थापन, झिल्ली सफाई और पानी की गुणवत्ता परीक्षण प्रदान करते हैं।',
    roService3Feature1: 'फिल्टर प्रतिस्थापन',
    roService3Feature2: 'झिल्ली सफाई',
    roService3Feature3: 'पानी परीक्षण',
    roService3Feature4: 'सिस्टम निरीक्षण',
    roService3Feature5: 'निवारक रखरखाव',
    roService3Feature6: 'आपातकालीन मरम्मत',
    roServicesWhyTitle: 'हमें क्यों चुनें?',
    roServicesWhySubtitle: 'पेशेवर जल शुद्धिकरण उत्कृष्टता',
    roServicesWhy1: 'विशेषज्ञ स्थापना',
    roServicesWhy1Desc: 'प्रमाणित तकनीशियनों द्वारा पेशेवर सेटअप',
    roServicesWhy2: 'गुणवत्ता आश्वासन',
    roServicesWhy2Desc: 'प्रीमियम RO सिस्टम और घटक',
    roServicesWhy3: 'नियमित सेवा',
    roServicesWhy3Desc: 'व्यापक रखरखाव और बिक्री के बाद सेवा',
    
    // About Section
    aboutBadge: '[ हमारे बारे में ]',
    aboutTitle: 'स्वागत है',
    aboutTitle2: 'Smart Security And RO Systems',
    aboutCard1Title: 'विशेष समाधान',
    aboutCard1Text: 'हम इलेक्ट्रॉनिक सुरक्षा बुनियादी ढांचे में अंत-से-अंत समाधान प्रदान करते हैं। हमारा फोकस सीसीटीवी निगरानी कैमरों, स्मार्ट सुरक्षा प्रणालियों, एक्सेस कंट्रोल सिस्टम, अलार्म सिस्टम और आवासीय, वाणिज्यिक और संस्थागत सुविधाओं के लिए एकीकृत सुरक्षा समाधानों की आपूर्ति, स्थापना, रखरखाव और सेवा पर है।',
    aboutCard2Title: '24/7 निगरानी',
    aboutCard2Text: 'ग्राहक-केंद्रित ऑपरेटिंग मॉडल के साथ, हम नई स्थापनाओं और बिक्री के बाद की सेवा आवश्यकताओं दोनों को संबोधित करते हैं, आवासीय, वाणिज्यिक और संस्थागत उपयोग के मामलों के लिए सिस्टम विश्वसनीयता, परिचालन निरंतरता और दीर्घकालिक प्रदर्शन सुनिश्चित करते हैं।',
    aboutBottomTitle: 'आपका विश्वसनीय सुरक्षा भागीदार',
    aboutBottomText: 'राप्तीनगर, गोरखपुर से संचालित, Smart Security And RO Systems खुद को एक विश्वसनीय स्थानीय भागीदार के रूप में स्थापित करती है, सुरक्षा और निगरानी की जरूरतों को कुशलतापूर्वक और लागत प्रभावी रूप से पूरा करने के लिए तकनीकी विशेषज्ञता के साथ उत्तरदायी सेवा वितरण को जोड़ती है।',
    
    // Services Section
    servicesBadge: '[ हमारी सेवाएं ]',
    servicesTitle: 'सुरक्षा',
    servicesTitle2: 'समाधान',
    servicesSubtitle: 'पेशेवर सीसीटीवी और जल शुद्धिकरण प्रणाली',
    service1Title: 'सीसीटीवी निगरानी कैमरे',
    service1Desc: 'व्यापक सुरक्षा निगरानी के लिए उन्नत सीसीटीवी कैमरा प्रणाली। एकल कैमरा सेटअप से लेकर जटिल मल्टी-कैमरा नेटवर्क तक, हम विश्वसनीय निगरानी समाधान प्रदान करते हैं।',
    service2Title: 'उन्नत सुरक्षा प्रणाली',
    service2Desc: 'AI-संचालित पहचान, चेहरे की पहचान और स्वचालित अलर्ट के साथ बुद्धिमान सुरक्षा समाधान। अत्याधुनिक तकनीक के साथ आपकी संपत्ति की पूर्ण सुरक्षा।',
    service3Title: 'एकीकृत सुरक्षा समाधान',
    service3Desc: 'एक्सेस कंट्रोल, अलार्म सिस्टम और एकीकृत सुरक्षा प्रबंधन सहित पूर्ण सुरक्षा बुनियादी ढांचा। आवासीय, वाणिज्यिक और संस्थागत जरूरतों के लिए अनुकूलित समाधान।',
    serviceButton: 'विवरण देखें',
    servicesWhyTitle: 'हमें क्यों चुनें?',
    servicesWhySubtitle: 'पेशेवर सुरक्षा समाधान और सेवा उत्कृष्टता',
    servicesWhy1: 'त्वरित प्रतिक्रिया',
    servicesWhy1Desc: 'तेज और कुशल सेवा वितरण',
    servicesWhy2: 'विशेषज्ञ स्थापना',
    servicesWhy2Desc: 'प्रमाणित तकनीशियनों द्वारा पेशेवर सेटअप',
    servicesWhy3: '24/7 सहायता',
    servicesWhy3Desc: 'व्यापक निगरानी और बिक्री के बाद सेवा',
    
    // Features Section
    featuresBadge: '[ उन्नत सुविधाएं ]',
    featuresTitle: 'स्मार्ट',
    featuresTitle2: 'तकनीक',
    featuresSubtitle: 'अंतिम सुरक्षा के लिए अत्याधुनिक सुरक्षा सुविधाएं',
    feature1Title: '24/7 लाइव निगरानी',
    feature1Desc: 'वास्तविक समय अलर्ट और तत्काल सूचनाओं के साथ चौबीसों घंटे निगरानी',
    feature2Title: 'AI-संचालित पहचान',
    feature2Desc: 'उन्नत गति पहचान और चेहरे की पहचान तकनीक',
    feature3Title: 'मोबाइल एक्सेस',
    feature3Desc: 'हमारे मोबाइल ऐप का उपयोग करके कहीं से भी अपनी संपत्ति की निगरानी करें',
    feature4Title: 'क्लाउड स्टोरेज',
    feature4Desc: 'आपके सभी निगरानी फुटेज के लिए सुरक्षित क्लाउड बैकअप',
    feature5Title: 'एन्क्रिप्टेड सुरक्षा',
    feature5Desc: 'आपके डेटा की सुरक्षा के लिए सैन्य-ग्रेड एन्क्रिप्शन',
    feature6Title: 'तत्काल अलर्ट',
    feature6Desc: 'संदिग्ध गतिविधि का पता चलने पर तुरंत सूचित हो जाएं',
    
    // RO Features Section
    roFeaturesBadge: '[ उन्नत सुविधाएं ]',
    roFeaturesTitle: 'शुद्ध पानी',
    roFeaturesTitle2: 'तकनीक',
    roFeaturesSubtitle: 'स्वच्छ, स्वस्थ पानी के लिए उन्नत जल शुद्धिकरण सुविधाएं',
    roFeature1Title: 'मल्टी-स्टेज फिल्ट्रेशन',
    roFeature1Desc: '7-चरणीय शुद्धिकरण प्रक्रिया जो अशुद्धियों, बैक्टीरिया और हानिकारक संदूषकों को हटाती है',
    roFeature2Title: 'TDS कंट्रोलर',
    roFeature2Desc: 'आवश्यक खनिजों को बनाए रखते हुए हानिकारक घुलित ठोस पदार्थों को हटाता है',
    roFeature3Title: 'UV नसबंदी',
    roFeature3Desc: 'पराबैंगनी तकनीक बैक्टीरिया और वायरस को समाप्त करती है, सुरक्षित पीने का पानी प्रदान करती है',
    roFeature4Title: 'ऑटो शट-ऑफ',
    roFeature4Desc: 'स्मार्ट सिस्टम टैंक भरने पर स्वचालित रूप से बंद हो जाता है, पानी और ऊर्जा बचाता है',
    roFeature5Title: 'खनिज प्रतिधारण',
    roFeature5Desc: 'स्वस्थ पानी के लिए कैल्शियम और मैग्नीशियम जैसे आवश्यक खनिजों को संरक्षित करता है',
    roFeature6Title: 'आसान रखरखाव',
    roFeature6Desc: 'इष्टतम प्रदर्शन के लिए सरल फिल्टर प्रतिस्थापन और नियमित सेवा',
    
    // Benefits Section
    benefitsBadge: '[ हमें क्यों चुनें ]',
    benefitsTitle: 'स्मार्ट सुरक्षा के',
    benefitsTitle2: 'लाभ',
    benefitsSubtitle: 'उन्नत निगरानी तकनीक के साथ सबसे महत्वपूर्ण चीजों की सुरक्षा करें',
    benefit1Title: 'मन की शांति',
    benefit1Desc: 'पेशेवर निगरानी प्रणालियों के साथ जानें कि आपकी संपत्ति 24/7 सुरक्षित है',
    benefit2Title: 'अपराध निवारक',
    benefit2Desc: 'दिखाई देने वाले कैमरे सेंधमारी और वैंडलिज्म के जोखिम को काफी कम करते हैं',
    benefit3Title: 'साक्ष्य संग्रह',
    benefit3Desc: 'बीमा दावों और कानूनी कार्यवाही के लिए उच्च गुणवत्ता वाला फुटेज',
    benefit4Title: 'दूरस्थ निगरानी',
    benefit4Desc: 'मोबाइल एक्सेस के माध्यम से कभी भी, कहीं भी अपनी संपत्ति की जांच करें',
    benefit5Title: 'लागत प्रभावी',
    benefit5Desc: 'स्वचालित निगरानी प्रणालियों के साथ सुरक्षा लागत कम करें',
    benefit6Title: 'पेशेवर सहायता',
    benefit6Desc: 'प्रमाणित तकनीशियनों द्वारा विशेषज्ञ स्थापना और निरंतर रखरखाव',
    
    // RO Benefits Section
    roBenefitsBadge: '[ हमें क्यों चुनें ]',
    roBenefitsTitle: 'RO जल शुद्धिकरण के',
    roBenefitsTitle2: 'लाभ',
    roBenefitsSubtitle: 'हर दिन स्वच्छ, स्वस्थ और शुद्ध पीने का पानी का आनंद लें',
    roBenefit1Title: 'शुद्ध और स्वस्थ पानी',
    roBenefit1Desc: 'क्रिस्टल साफ, संदूषक-मुक्त पानी प्राप्त करें जो आपके पूरे परिवार के लिए सुरक्षित है',
    roBenefit2Title: 'बेहतर स्वाद',
    roBenefit2Desc: 'अप्रिय गंध और स्वाद को हटाएं, पानी को ताज़ा और आनंददायक बनाएं',
    roBenefit3Title: 'स्वास्थ्य सुरक्षा',
    roBenefit3Desc: 'हानिकारक बैक्टीरिया, वायरस और रसायनों को समाप्त करें जो स्वास्थ्य समस्याएं पैदा कर सकते हैं',
    roBenefit4Title: 'लागत बचत',
    roBenefit4Desc: 'बोतलबंद पानी पर पैसे बचाएं और प्लास्टिक कचरे को कम करें',
    roBenefit5Title: 'सुविधा',
    roBenefit5Desc: 'अपने नल से 24/7 शुद्ध पानी तक पहुंचें, पानी स्टोर करने या खरीदने की आवश्यकता नहीं',
    roBenefit6Title: 'खनिज संतुलन',
    roBenefit6Desc: 'TDS कंट्रोलर सुनिश्चित करता है कि स्वस्थ पीने के पानी के लिए आवश्यक खनिज बनाए रखे जाएं',
    
    // Testimonials Section
    testimonialsBadge: '[ ग्राहक प्रतिक्रिया ]',
    testimonialsTitle: 'हमारे ग्राहक',
    testimonialsTitle2: 'क्या कहते हैं',
    testimonialsSubtitle: 'सैकड़ों संतुष्ट ग्राहकों द्वारा विश्वसनीय',
    testimonial1Name: 'राजेश कुमार',
    testimonial1Role: 'व्यवसाय मालिक',
    testimonial1Text: 'Smart Security And RO Systems ने मेरी दुकान पर सीसीटीवी कैमरे स्थापित किए। गुणवत्ता उत्कृष्ट है और सेवा असाधारण है। मैं कहीं से भी अपनी दुकान की निगरानी कर सकता हूं। अत्यधिक अनुशंसित!',
    testimonial2Name: 'प्रिया शर्मा',
    testimonial2Role: 'गृहस्वामी',
    testimonial2Text: 'पेशेवर स्थापना और बेहतरीन सहायता। कैमरे रात में भी बिल्कुल स्पष्ट हैं। मोबाइल ऐप बहुत उपयोगकर्ता के अनुकूल है। अब बहुत सुरक्षित महसूस करते हैं!',
    testimonial3Name: 'अमित सिंह',
    testimonial3Role: 'कारखाना प्रबंधक',
    testimonial3Text: 'हमने अपने कारखाने में उनकी सुरक्षा प्रणाली स्थापित की। कवरेज व्यापक है और 24/7 निगरानी हमें पूर्ण मन की शांति देती है। पैसे के लिए उत्कृष्ट मूल्य।',
    testimonial4Name: 'सुनीता देवी',
    testimonial4Role: 'स्कूल प्रधानाचार्य',
    testimonial4Text: 'सुरक्षा प्रणाली हमारे स्कूल के लिए एक गेम-चेंजर रही है। माता-पिता अधिक सुरक्षित महसूस करते हैं और हमारे पास परिसर पर बेहतर नियंत्रण है। पेशेवर टीम और बेहतरीन सेवा!',
    testimonial5Name: 'विक्रम पटेल',
    testimonial5Role: 'रेस्तरां मालिक',
    testimonial5Text: 'मेरे रेस्तरां में कैमरे स्थापित किए। रात्रि दृष्टि अद्भुत है और क्लाउड स्टोरेज बहुत सुविधाजनक है। ग्राहक सेवा उत्तरदायी और सहायक है।',
    
    // RO Testimonials
    roTestimonial1Name: 'राजेश कुमार',
    roTestimonial1Role: 'गृहस्वामी',
    roTestimonial1Text: 'मेरे घर में RO सिस्टम स्थापित किया। पानी की गुणवत्ता उत्कृष्ट है और स्वाद बेहतरीन है। स्थापना त्वरित और पेशेवर थी। सेवा से अत्यधिक संतुष्ट!',
    roTestimonial2Name: 'प्रिया शर्मा',
    roTestimonial2Role: 'परिवार',
    roTestimonial2Text: 'हमारा सबसे अच्छा निर्णय! RO सिस्टम हमारे पूरे परिवार के लिए स्वच्छ, शुद्ध पानी प्रदान करता है। रखरखाव सेवा त्वरित है और टीम बहुत सहायक है।',
    roTestimonial3Name: 'अमित सिंह',
    roTestimonial3Role: 'कार्यालय प्रबंधक',
    roTestimonial3Text: 'हमारे कार्यालय में वाणिज्यिक RO सिस्टम स्थापित किया। उच्च क्षमता और उत्कृष्ट पानी की गुणवत्ता। कर्मचारी स्वच्छ पीने के पानी से प्यार करते हैं। बेहतरीन निवेश!',
    roTestimonial4Name: 'सुनीता देवी',
    roTestimonial4Role: 'रेस्तरां मालिक',
    roTestimonial4Text: 'RO सिस्टम ने हमारे रेस्तरां के संचालन में सुधार किया है। खाना पकाने और पीने के लिए स्वच्छ पानी। ग्राहक गुणवत्ता की सराहना करते हैं। पेशेवर स्थापना और सेवा!',
    roTestimonial5Name: 'विक्रम पटेल',
    roTestimonial5Role: 'दुकान मालिक',
    roTestimonial5Text: 'RO रखरखाव सेवा उत्कृष्ट है। नियमित फिल्टर प्रतिस्थापन और पानी की जांच सुनिश्चित करती है कि हमारे पास हमेशा शुद्ध पानी हो। बहुत विश्वसनीय और किफायती सेवा।',
    
    // Contact Section
    contactBadge: '[ हमसे संपर्क करें ]',
    contactTitle: 'संपर्क',
    contactTitle2: 'करें',
    contactSubtitle: 'पेशेवर सुरक्षा और जल समाधान परामर्श',
    contactInfoTitle: 'संपर्क जानकारी',
    contactPhone: 'फोन',
    contactEmail: 'ईमेल',
    contactLocation: 'स्थान',
    contactWebsite: 'वेबसाइट',
    contactHours: 'व्यावसायिक घंटे',
    contactFormTitle: 'हमें संदेश भेजें',
    contactName: 'नाम *',
    contactEmailPlaceholder: 'आपका.ईमेल@उदाहरण.com',
    contactPhonePlaceholder: '+91 9876543210',
    contactMessage: 'संदेश *',
    contactMessagePlaceholder: 'हमें अपनी सुरक्षा आवश्यकताओं के बारे में बताएं...',
    contactSubmit: 'संदेश भेजें',
    contactMonday: 'सोमवार - शनिवार',
    contactSunday: 'रविवार',
    
    // Footer
    footerQuickLinks: 'त्वरित लिंक',
    footerContactInfo: 'संपर्क जानकारी',
    footerAbout: 'हमारे बारे में',
    footerServices: 'सेवाएं',
    footerContact: 'संपर्क',
    footerActive: '[ सक्रिय ]',
    footerSolutions: 'सुरक्षा और जल समाधान',
    
    // Owner Section
    ownerBadge: '[ स्वामी विवरण ]',
    ownerTitle: 'स्वामी से',
    ownerTitle2: 'मिलें',
    ownerSubtitle: 'आपका विश्वसनीय सुरक्षा और जल समाधान विशेषज्ञ',
    ownerName: 'श्री अशीष कुमार',
    ownerExperience: 'वर्षों का अनुभव',
    ownerContact: 'संपर्क विवरण',
    ownerEmail: 'ईमेल',
    ownerPhone: 'फोन',
  }
};

